<header class="header flex items-center justify-end p-2 sm:p-3 md:p-4 absolute top-2 sm:top-4 right-2 sm:right-4 z-10">
    <a routerLink="/" class="home-btn flex items-center justify-center text-white mr-2 min-h-[44px] min-w-[44px]">
        <ng-icon name="ionHomeOutline" class="text-xl sm:text-2xl md:text-3xl" />
    </a>
    <app-language-switcher></app-language-switcher>
</header>